<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header"></div>
            <div class="card-body">
              <div v-if="loadingIntegration" class="integration-loading">
                <small class="text-muted">
                  <i class="fas fa-spinner fa-spin mr-1"></i>
                  Checking FastMedic integration...
                </small>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label>Nome</label>
                  <input
                      v-model="professionals.name"
                      class="form-control"
                      type="text"
                  />
                </div>
                <div class="col-md-3">
                  <label for="cpf">CPF:</label>
                  <div class="input-group">
                    <input
                        v-model="professionals.cpf"
                        v-mask="'999.999.999-99'"
                        class="form-control"
                        type="text"
                        placeholder="000.000.000-00"
                        @input="onCpfChange"
                        @blur="validateCpf"
                        @focus="clearCpfValidation"
                    />
                    <div v-if="showFastMedicButton" class="input-group-append">
                      <button
                          @click="searchFastMedic"
                          :disabled="!canSearchFastMedic"
                          class="btn btn-info"
                          type="button"
                          :title="searchButtonTooltip"
                      >
                        <i v-if="loadingFastMedic" class="fas fa-spinner fa-spin"></i>
                        <i v-else class="fas fa-search"></i>
                      </button>
                    </div>
                  </div>

                  <div class="feedback-messages">
                    <small v-if="errorFastMedic" class="text-danger d-block">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      {{ errorFastMedic }}
                    </small>

                    <small v-else-if="fastMedicDataLoaded && !errorFastMedic" class="text-success d-block">
                      <i class="fas fa-check mr-1"></i>
                      Usuário encontrado e formulário preenchido!
                    </small>

                    <small v-else-if="showCpfValidationError" class="text-warning d-block">
                      <i class="fas fa-exclamation-triangle mr-1"></i>
                      Formato de CPF inválido
                    </small>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="rg">SUS:</label>
                  <input
                      v-model="professionals.rg"
                      class="form-control"
                      type="text"
                  />
                </div>
                <div class="col-md-4">
                  <label for="advice_id">Conselho:</label>
                  <v-select
                      v-model="professionals.advice_id"
                      class="vselect"
                      :options="advice"
                      :reduce="(advice) => advice.id"
                      :label="'title'"
                      :loading="loadingAdvice"
                  />
                </div>
                <div class="col-md-3">
                  <label for="number_advice">Número do Conselho:</label>
                  <input
                      v-model="professionals.number_advice"
                      class="form-control"
                      type="text"
                  />
                </div>
                <div class="col-md-5">
                  <label for="specialty_id">Especialidade:</label>
                  <v-select
                      v-model="professionals.specialty_id"
                      class="vselect"
                      :options="specialties"
                      :reduce="(specialties) => specialties.id"
                      :label="'title'"
                      :loading="loadingSpecialties"
                  />
                </div>

                <div class="col-md-4">
                  <label>CEP</label>
                  <input
                      type="text"
                      v-model="professionals.cep"
                      class="form-control"
                      v-on:keyup="searchAddress"
                      v-mask="'99999-999'"
                  />
                </div>
                <div class="col-md-8">
                  <label>Logradouro</label>
                  <input
                      type="text"
                      v-model="professionals.logradouro"
                      class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label>Complemento</label>
                  <input
                      type="text"
                      v-model="professionals.complement"
                      class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label>Número</label>
                  <input
                      type="text"
                      v-model="professionals.number"
                      class="form-control"
                      id="inputNumero"
                  />
                </div>
                <div class="col-md-4">
                  <label>Bairro</label>
                  <input
                      type="text"
                      v-model="professionals.neighborhood"
                      class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label>Cidade</label>
                  <input
                      type="text"
                      v-model="professionals.city"
                      class="form-control"
                  />
                </div>
                <div class="col-md-2">
                  <label>Estado</label>
                  <input
                      type="text"
                      v-model="professionals.state"
                      class="form-control"
                  />
                </div>

                <div class="col-md-10 mt-3">
                  <label>Empresa</label>
                  <v-select
                      v-model="company_selected"
                      class="vselect"
                      :options="companies"
                      :label="'fantasy_name'"
                      :loading="loadingCompanies"
                  />
                </div>

                <div class="col-md-2 mt-5">
                  <button
                      class="btn btn-add"
                      style="margin-top: 12px"
                      @click="addCompany"
                  >
                    Adicionar
                  </button>
                </div>

                <div
                    class="col-md-12 mt-2"
                    v-if="professionals.companies.length > 0"
                >
                  <h3>Empresas Vinculadas</h3>
                </div>
                <div
                    class="col-md-12 mt-1"
                    v-if="professionals.companies.length > 0"
                >
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Razão Social</th>
                      <th scope="col">Nome Fantasia</th>
                      <th scope="col">CNPJ</th>
                      <th scope="col">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(company, index) in professionals.companies"
                        :key="company.id"
                    >
                      <th scope="row">{{ index + 1 }}</th>
                      <td>{{ company.name }}</td>
                      <td>{{ company.fantasy_name }}</td>
                      <td>{{ company.cnpj }}</td>
                      <td>
                        <button
                            class="btn btn-crud delete"
                            @click="removeItem(index)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-12 text-right">
                  <hr/>
                  <router-link to="/professionals" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"/>
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "ProfessionalForm",
  components: {
    BaseCrud,
    vSelect,
  },
  data() {
    return {
      company_selected: {},
      specialties: [],
      companies: [],
      advice: [],
      loadingIntegration: false,
      loadingSpecialties: false,
      loadingAdvice: false,
      loadingCompanies: false,
      loadingFastMedic: false,
      errorFastMedic: null,
      fastMedicData: null,
      fastMedicDataLoaded: false,
      hasIntegrationActive: false,
      userCompanyId: null,
      cpfValidationTimer: null,
      cpfValidationError: null,
      professionals: {
        name: "",
        cpf: "",
        rg: "",
        advice_id: "",
        specialty_id: "",
        state: "",
        logradouro: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        cep: "",
        cbo_id: "",
        companies: [],
        number_advice: "",
      },
    };
  },
  computed: {
    cpfValid() {
      if (!this.professionals.cpf) return false;
      const cleanCpf = this.professionals.cpf.replace(/[^\d]/g, '');
      return cleanCpf.length === 11 && this.isValidCpf(cleanCpf);
    },

    showFastMedicButton() {
      return this.hasIntegrationActive || this.loadingIntegration;
    },

    canSearchFastMedic() {
      return !this.loadingIntegration &&
          !this.loadingFastMedic &&
          this.cpfValid &&
          this.hasIntegrationActive;
    },

    searchButtonTooltip() {
      if (this.loadingIntegration) return 'Checking integration...';
      if (!this.cpfValid) return 'Enter a valid CPF';
      if (!this.hasIntegrationActive) return 'FastMedic integration not available';
      if (this.loadingFastMedic) return 'Searching...';
      return 'Search CPF in FastMedic';
    },

    showCpfValidationError() {
      return this.cpfValidationError && !this.errorFastMedic;
    }
  },
  mounted() {
    this.initializeForm();
  },
  methods: {
    initializeForm() {
      this.checkUserIntegration();
      this.loadFormData();

      const id = this.$route.params.id;
      if (id) {
        this.getProfessional(id);
      }
    },

    async checkUserIntegration() {
      this.loadingIntegration = true;

      try {
        await this.getCurrentUserWithCompanyId();

        if (this.userCompanyId) {
          await this.checkCompanyIntegration();
        }
      } finally {
        this.loadingIntegration = false;
      }
    },

    loadFormData() {
      this.getSpecialties();
      this.getAdvices();
      this.getCompanies();
    },

    async getCurrentUserWithCompanyId() {
      try {
        const token = this.$store.state.token || localStorage.getItem('token');
        if (!token) return;

        const response = await axios.post(this.$store.state.api + 'me', {token});
        this.userCompanyId = response.data.company_id || response.data.local?.company_id || null;
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    },

    async checkCompanyIntegration() {
      if (!this.userCompanyId) {
        this.hasIntegrationActive = false;
        return;
      }

      try {
        const response = await axios.get(`${this.$store.state.api}companies/${this.userCompanyId}`);
        const company = this.getCompanyFromResponse(response.data);
        this.hasIntegrationActive = company ? Boolean(company.fastmedic_integration) : false;
      } catch (error) {
        this.hasIntegrationActive = false;
      }
    },

    getCompanyFromResponse(responseData) {
      if (responseData?.data?.data?.[0]) return responseData.data.data[0];
      if (responseData?.data?.[0]) return responseData.data[0];
      if (responseData?.[0]) return responseData[0];
      if (responseData?.id) return responseData;
      return null;
    },

    onCpfChange() {
      if (this.errorFastMedic) {
        this.errorFastMedic = null;
      }

      this.cpfValidationError = null;

      if (this.cpfValidationTimer) {
        clearTimeout(this.cpfValidationTimer);
      }
    },

    validateCpf() {
      const cleanCpf = this.professionals.cpf ? this.professionals.cpf.replace(/[^\d]/g, '') : '';

      if (cleanCpf.length === 11) {
        if (!this.cpfValid) {
          this.cpfValidationError = 'Formato de CPF inválido';

          setTimeout(() => {
            this.cpfValidationError = null;
          }, 5000);
        } else {
          this.cpfValidationError = null;
        }
      } else if (cleanCpf.length > 0) {
        this.cpfValidationError = null;
      }
    },

    clearCpfValidation() {
      this.cpfValidationError = null;

      if (this.cpfValidationTimer) {
        clearTimeout(this.cpfValidationTimer);
      }
    },

    async searchFastMedic() {
      if (!this.canSearchFastMedic) return;

      this.loadingFastMedic = true;
      this.errorFastMedic = null;
      this.fastMedicData = null;
      this.fastMedicDataLoaded = false;
      this.cpfValidationError = null;

      try {
        const response = await axios.post(
            this.$store.state.api + 'fastmedic-integration',
            {cpf: this.professionals.cpf}
        );

        if (!response.data.success) {
          this.clearFastMedicFields();
          this.errorFastMedic = response.data.message || 'Nenhum dado encontrado para este CPF';
          this.$message(null, this.errorFastMedic, 'error');

          setTimeout(() => {
            this.errorFastMedic = null;
          }, 6000);
          return;
        }

        if (!response.data.data || !Array.isArray(response.data.data) || response.data.data.length === 0) {
          this.clearFastMedicFields();
          this.errorFastMedic = 'Nenhum dado encontrado para este CPF';
          this.$message(null, this.errorFastMedic, 'error');

          setTimeout(() => {
            this.errorFastMedic = null;
          }, 6000);
          return;
        }

        this.fastMedicData = response.data.data;
        this.fillFormWithFastMedicData();
        this.fastMedicDataLoaded = true;
        this.$message('Success', 'Usuário encontrado e formulário preenchido com sucesso!', 'success');

        setTimeout(() => {
          this.fastMedicDataLoaded = false;
        }, 3000);

      } catch (error) {
        const errorMsg = error.response?.data?.message || 'Error connecting to FastMedic';
        this.errorFastMedic = errorMsg;
        this.clearFastMedicFields();
        this.$message(null, errorMsg, 'error');

        setTimeout(() => {
          this.errorFastMedic = null;
        }, 6000);
      } finally {
        this.loadingFastMedic = false;
      }
    },

    clearFastMedicFields() {
      var fields = ['rg', 'name', 'number_advice', 'cbo_id', 'cep', 'logradouro', 'complement', 'number', 'neighborhood', 'city', 'state'];
      for (var i = 0; i < fields.length; i++) {
        this.professionals[fields[i]] = '';
      }
      this.fastMedicData = null;
      this.fastMedicDataLoaded = false;
    },

    isValidCpf(cpf) {
      if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let digit = 11 - (sum % 11);
      if (digit === 10 || digit === 11) digit = 0;
      if (digit !== parseInt(cpf.charAt(9))) return false;

      sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf.charAt(i)) * (11 - i);
      }
      digit = 11 - (sum % 11);
      if (digit === 10 || digit === 11) digit = 0;
      return digit === parseInt(cpf.charAt(10));
    },

    fillFormWithFastMedicData() {
      if (!this.fastMedicData || !Array.isArray(this.fastMedicData) || this.fastMedicData.length === 0) return;
      const data = this.fastMedicData[0];

      const fieldMap = {
        rg: ['numCNSProfissional'],
        cpf: ['numCPFProfissional'],
        name: ['nomeProfissionalSolicitante'],
        number_advice: ['numConsRegistroProfissional'],
        cbo_id: ['numCboProfissional'],
        cep: ['numCepProfissional'],
        logradouro: ['dscLogradouroProfissional'],
        complement: ['dscComplementoProfissional'],
        number: ['numEnderecoProfissional'],
        neighborhood: ['dscBairroProfissional'],
        city: ['dscCidadeProfissional'],
        state: ['dscEstadoProfissional']
      };

      Object.keys(fieldMap).forEach(dest => {
        const keys = fieldMap[dest];
        let value = null;
        for (let i = 0; i < keys.length; i++) {
          const k = keys[i];
          if (data.hasOwnProperty(k) && data[k] != null && data[k] !== '') {
            value = data[k];
            break;
          }
        }
        this.professionals[dest] = value != null ? value : '';
      });

      this.fillAddressFields(data);

      this.selectCouncilByCode(data.sgOrgaoProfissional);

      this.fastMedicData = null;
    },

    fillAddressFields(data) {
      const addressMappings = [
        ['cep', 'numCepProfissional'],
        ['logradouro', 'dscLogradouroProfissional'],
        ['number', 'numEnderecoProfissional'],
        ['complement', 'dscComplementoProfissional'],
        ['neighborhood', 'dscBairroProfissional'],
        ['city', 'dscCidadeProfissional'],
        ['state', 'dscEstadoProfissional']
      ];

      addressMappings.forEach(([localField, dataField]) => {
        if (!this.professionals[localField] && data[dataField]) {
          this.professionals[localField] = data[dataField];
        }
      });
    },

    selectCouncilByCode(code) {
      if (!this.advice.length) {
        this.professionals.advice_id = '';
        return;
      }

      if (!code) {
        this.professionals.advice_id = '';
        return;
      }

    const council = this.advice.find(function(adviceItem) {
      return adviceItem.codigo === code ||
         adviceItem.code === code ||
         String(adviceItem.codigo) === String(code) ||
         String(adviceItem.code) === String(code);
    });

      this.professionals.advice_id = council ? council.id : '';
    },

    removeItem(index) {
      this.professionals.companies.splice(index, 1);
    },

    addCompany() {
      if (!this.company_selected) return;
      this.professionals.companies.push(this.company_selected);
    },

    async save() {
      try {
        let api = this.$store.state.api + "professionals";
        const formData = {...this.professionals};

        if (this.professionals.id) {
          formData._method = "PUT";
          api += "/" + this.professionals.id;
        }

        await axios.post(api, formData);
        this.$message("Success", "Information saved successfully", "success");
        this.$router.push("/professionals");
      } catch (error) {
        this.$message(null, error.response.data, "error");
      }
    },

    async getSpecialties() {
      this.loadingSpecialties = true;
      try {
        const api = this.$store.state.api + "specialties?paginated=false";
        const response = await axios.get(api);
        this.specialties = response.data.data || [];
      } catch (error) {
        this.$message(null, 'Error loading specialties', "error");
      } finally {
        this.loadingSpecialties = false;
      }
    },

    async getAdvices() {
      this.loadingAdvice = true;
      try {
        const api = this.$store.state.api + "advice?paginated=false";
        const response = await axios.get(api);
        this.advice = response.data.data || [];
      } catch (error) {
        this.$message(null, 'Error loading advices', "error");
      } finally {
        this.loadingAdvice = false;
      }
    },

    async getCompanies() {
      this.loadingCompanies = true;
      try {
        const api = this.$store.state.api + "companies?paginated=false";
        const response = await axios.get(api);
        this.companies = response.data.data || [];
      } catch (error) {
        this.$message(null, 'Error loading companies', "error");
      } finally {
        this.loadingCompanies = false;
      }
    },

    async getProfessional(id) {
      try {
        const api = this.$store.state.api + "professionals/" + id + "?with[]=companies";
        const response = await axios.get(api);
        this.professionals = response.data.data[0];
      } catch (error) {
        this.$message(null, 'Error loading professional', "error");
      }
    },

    searchAddress() {
      if (!this.isValidCep(this.professionals.cep)) return;

      this.addressNotFound = false;

      $.getJSON(
          "https://viacep.com.br/ws/" + this.professionals.cep + "/json/",
          (address) => {
            if (address.erro) {
              this.endereco = {};
              $("#inputNumero").focus();
              this.addressNotFound = true;
              return;
            }

            this.populateAddressFields(address);
            $("#inputNumero").focus();
          }
      );
    },

    isValidCep(cep) {
      return /^[0-9]{5}-[0-9]{3}$/.test(cep);
    },

    populateAddressFields(address) {
      this.endereco = address;
      this.professionals.logradouro = address.logradouro;
      this.professionals.complement = address.complemento;
      this.professionals.neighborhood = address.bairro;
      this.professionals.city = address.localidade;
      this.professionals.state = address.uf;
    }
  }
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.input-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.badge {
  font-size: 0.75em;
}

.text-success {
  font-size: 0.85em;
}

.text-warning {
  font-size: 0.85em;
}

.integration-loading {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 100;
}

.card {
  position: relative;
}


.feedback-messages {
  min-height: 20px;
}

.d-block {
  display: block !important;
}
</style>